import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  fromEvent,
  takeUntil,
  tap,
} from 'rxjs';
import { BaseUnsubscribeComponent } from 'src/app/shared-new/components/base-unsubscribe/base-unsubscribe.component';
import {
  RepoBusiness,
  RepoBusinessTableFields,
  RepoPosition,
} from '../../models/repo-business/repo-business.model';

import { AuthService } from 'src/app/services/auth.service';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { RepoBusinessFacade } from '../../shared-new/store/repo-business/repo-business.facade';
import { RepoBusinessListDataSource } from './repo-business-list-datasource';
import { RepoContactOrgPopupComponent } from '../repo-contact-org-popup/repo-contact-org-popup.component';
import { MatSort } from '@angular/material/sort';
import Swal from 'sweetalert2';
import { ToastService } from '../../shared-new/services/toast.service';

@Component({
  selector: 'app-repo-business-list',
  templateUrl: './repo-business-list.component.html',
  styleUrls: ['./repo-business-list.component.scss'],
})
export class RepoBusinessListComponent
  extends BaseUnsubscribeComponent
  implements OnInit, OnDestroy, AfterViewInit {
  public RepoBusinessTableFields = RepoBusinessTableFields;
  @ViewChild(MatSort) businessSort: MatSort;
  private _searchTerm: string = '';
  @Input() public set searchTerm(value: string) {
    this._searchTerm = value;
    if (this.dataSource) {
      this.dataSource.searchTable(value);
    }
  }
  public get searchTerm(): string {
    return this._searchTerm;
  }    
  @Input() public set businesses(businesses: RepoBusiness[]) {
    if (businesses) {
      setTimeout(() => {
        const scrollLevel = this.dataSource?.infiniteScrollLevel || 20;
        this.dataSource = new RepoBusinessListDataSource(businesses, this.businessSort, false, scrollLevel);
        if (this.searchTerm) {
          this.dataSource.searchTable(this.searchTerm);
        }
      }, 100);
    }
  }

 
  public dataSource: RepoBusinessListDataSource;
  public repoBusinesses: RepoBusiness[];
  public isLoader: boolean = false;
  @Input() public isUSA = false;
  error$ = this.repoBusinessFacade.error$;
  success$ = this.repoBusinessFacade.success$;
  loading$ = this.repoBusinessFacade.loading$;
  public displayedColumns$ = new BehaviorSubject([
    'businessName',
    'address',
    'addressLine2',
    'suburb',
    'stateName',
    'countryName',
    'postCode',
    'website',
    'contacts',
    'options',
  ]);

  private _positionData: any = { viewMode: true };

  public get positionData(): any {
    return this._positionData;
  }

  public set positionData(value: any) {
    this._positionData = value;
  }


  private _contactsData: any = {
    businessId: 0,
    businessName: '',
    viewMode: true
  };

  
  public get contactData(): any {
    return this._contactsData;
  }

  public set contactData(value: any) {
    this._contactsData = value;
  }



  @Input() positionsUpdated: BehaviorSubject<RepoPosition[]> = new BehaviorSubject<RepoPosition[]>([]);
  @Output() editRepoBusiness = new EventEmitter();
  private _positions: RepoPosition[];
  @Input() public set positions(positions: RepoPosition[]) {
    this._positions = positions;
  };
  public get positions(): RepoPosition[] {
    return this._positions;
  }
  constructor(
    private readonly modalService: NgbModal,
    private readonly repoBusinessFacade: RepoBusinessFacade,
    private httpErrorHandlerService: HttpErrorHandlerService,
    private authService: AuthService,
    private toastService: ToastService
  ) {
    super();
  }
  public get OrgTitle(): string {
    return this.isUSA ? 'Organizations' : 'Organisations';
  }
  public ngOnInit(): void {
    this.attachEvents();
  }
  private attachEvents(): void {
    this.success$.pipe(takeUntil(this.unsubscribe$)).subscribe((response) => {
      if (response?.deleteBusiness) {
        this.toastService.success('Business Deleted', 'Success!');
        this.repoBusinessFacade.loadRepoBusinesses();
        this.repoBusinessFacade.loadContacts();
      }
    });
  }

  public trackByBusiness(index: number, business: RepoBusiness): number {
    return business.repoBusinessId;
  }
  
  openAddPopup(business: RepoBusiness, viewMode: boolean = true, contactId:number = 0): void {
    this.repoBusinessFacade.loadContactsByRepoBusinessId(business.repoBusinessId);
    const modalRef = this.modalService.open(RepoContactOrgPopupComponent, {
      size: '50-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.isViewMode = viewMode;
    modalRef.componentInstance.business = business;
    modalRef.componentInstance.contactId = contactId;
    modalRef.componentInstance.isUSA = this.isUSA;
    
  }

  openRepoBusinessPopup(business: RepoBusiness): void {
    this.editRepoBusiness.emit(business);
  }
 


  public sanitizeUrl(url: string): string {
    if (!/^https?:\/\//i.test(url)) {
      return 'http://' + url;
    }
    return url;
  }
 
  public ngAfterViewInit(): void {

  }

  public onTableScroll(): void {
    this.dataSource.onScroll();
  }

  public override ngOnDestroy(): void {
    this.unsubscribe$.next();
  }

  public DeleteRepoBusiness(business: RepoBusiness): void {
    let confirmText = '';
    if (business.contacts.length > 0) {
      confirmText = `<i class="fa fa-exclamation-circle text-danger"></i>&nbsp;This ${this.OrgTitle} is used in other contacts. They will be updated to have no ${this.OrgTitle}.<br /><br />`;
    }

    Swal.fire({
      title: 'Remove ' + this.OrgTitle,
      html: `${confirmText}Are you sure you want to remove the ${this.OrgTitle}? This is an irreversible action.`,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Delete',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.value) {
        this.repoBusinessFacade.deleteBusiness(business.repoBusinessId);
      }
    });

  }
}
